/**
 * 路由配置信息
 *
 * @author terrfly
 * @site https://www.techpayx.vip
 * @date 2021/5/8 07:18
 */

import Vue from 'vue'
import VueRouter from 'vue-router'

// hack router push callback
// [解决 vue-router跳转相同路径报错 ]
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}


Vue.use(VueRouter)

const routes = [
  {path: '/hub/:techpayxToken?', name: 'Hub', component: () => import('../views/Hub.vue')}, //自动分发器
  {path: '/error', name: 'Error', component: () => import('../views/Error.vue')},
  {path: '/apps', name: 'Apps', component: () => import('../views/Apps.vue')}, //商家应用聚合页（无需白名单/鉴权）
  {path: '/oauth2Callback/:techpayxToken?', name: 'Oauth2Callback', component: () => import('../views/Oauth2Callback.vue')}, //oauth回调地址
  {path: '/cashier', name: 'Cashier', component: () => import('../views/Cashier.vue'), //收银台（该地址无意义）
    children: [
        { path: '/cashier/index', name: 'CashierIndex', component: () => import('../views/payway/Index') },
        { path: '/cashier/wxpay', name: 'CashierWxpay', component: () => import('../views/payway/Wxpay.vue') },
        { path: '/cashier/alipay', name: 'CashierAlipay', component: () => import('../views/payway/Alipay.vue') },
        { path: '/cashier/ysfpay', name: 'CashierYsfpay', component: () => import('../views/payway/Ysfpay.vue') },
        { path: '/cashier/invoice', name: 'CashierInvoice', component: () => import('../views/payway/Invoice.vue') },
        // 微信点金计划：支付成功后使用 location.replace 全路径打开，勿删；需在商户平台配置白名单
        { path: '/cashier/wxpay-pay-success', name: 'CashierWxpayPaySuccess', component: () => import('../views/payway/WxpayPaySuccess.vue') }
    ]
  }
]

const router = new VueRouter({
  mode: 'history', // history 模式，URL 更美观，需要服务器配置支持
  base: "",
  routes
})

export default router
